import React from 'react';
import OurProjects from '../components/OurProjects'; // adjust path as necessary

const OurProjectsPage = () => {
  return (
    <>
      <OurProjects />
    </>
  );
};

export default OurProjectsPage;
